import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Tabs,
  Modal,
  message,
  Divider,
} from "antd";
import qs from "qs";
import {
  ROW_JUSTIFY,
  LOCAL_LANG,
  SNS_CALLBACK_URL,
  EMAIL_ACTION_TYPE,
} from "../common/const";
import {
  GetLoginStatus,
  PostAuthLogin,
  PostEmailSend,
  PostTeamJoin,
  PostEmailRegisterCheck,
  PostEmailRegisterSend,
} from "../config/request";
import errCode from "../config/errCode";
import { useEvent } from "../common/useEvent.js";
import {
  CheckEmail,
  googleStatis,
  CheckSystem,
  getUrlParam,
  OpenBrowserUrl,
  openRedirectUrl,
  getDeviceType,
  getNextPathByRegisterStatus,
  getRedirectUrl,
} from "../common/globalFun";
import { useIntl } from "react-intl";

import HeaderLogo from "../components/HeaderLogo";
import BackHeader from "../components/BackHeader";
import ErrorHintText from "../components/ErrorHintText";

import "./css/style.css";

import { ReactComponent as GithubIcon } from "../res/img/github.svg";
import { ReactComponent as FaceBookIcon } from "../res/img/facebook.svg";
import { ReactComponent as TwitterIcon } from "../res/img/twitter.svg";
import { ReactComponent as GoogleIcon } from "../res/img/google.svg";

const { TabPane } = Tabs;

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

const LoginPage = (props) => {
  const { history } = props;
  const intl = useIntl();
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const [isClient] = useState(CheckSystem.Felo());
  // 1: 登录页 2: 忘记密码页/注册页
  const [tabsActiveKey, setTabsActiveKey] = useState("1");
  const [loading, setLoading] = useState(false);
  const [emailStatus, setEmailStatus] = useState({
    validateStatus: "",
    errorMsg: null,
  });
  const [accountStatus, setAccountStatus] = useState({
    validateStatus: "",
    errorMsg: null,
  });
  const [passwordStatus, setPasswordStatus] = useState({
    validateStatus: "",
    errorMsg: null,
  });

  const [password, setPassword] = useState("");
  const [nextStepType, setNextStepType] = useState(""); // 区分是注册还是找回密码
  const [pwdModalVisible, setPwdModalVisible] = useState(false);

  const togglePwdModalVisible = () => {
    setPwdModalVisible(!pwdModalVisible);
  };

  const goSetPwd = () => {
    togglePwdModalVisible();
    emailActionType(EMAIL_ACTION_TYPE.FINDPWD);
  };

  const showBackBtn = () => {
    const isIFrame = inIframe();
    return isIFrame && props.redirectUri;
  };

  const emailOnChange = (e) => {
    const email = e.target.value;
    emailChangeCheck(email, setEmailStatus);
  };

  const accountOnChange = (e) => {
    const email = e.target.value;
    emailChangeCheck(email, setAccountStatus);
  };

  const inputFocus = () => {
    let input;
    if (tabsActiveKey === "1") {
      input = form.getFieldInstance("email");
    } else if (tabsActiveKey === "2") {
      input = form.getFieldInstance("account");
    }
    input.focus();
  };

  const emailActionType = (type) => {
    setTabsActiveKey(type ? "2" : "1");
    setNextStepType(type);
  };

  const emailChangeCheck = (value, setMethod) => {
    if (CheckEmail(value)) {
      setMethod({
        validateStatus: "success",
        errorMsg: null,
      });
      return;
    }

    setMethod({
      validateStatus: "",
      errorMsg: null,
    });
  };

  const pwdOnChange = (e) => {
    const pwd = e.target.value;
    setPassword(pwd);
  };

  const submitBtnDisabled = () => {
    switch (tabsActiveKey) {
      case "1":
        return emailStatus.validateStatus !== "success" || !password;
      case "2":
        return accountStatus.validateStatus !== "success";
      default:
        break;
    }
  };

  const submitCheck = (value, setMethod) => {
    if (!value) {
      setMethod({
        validateStatus: "error",
        errorMsg: (
          <span>{intl.formatMessage({ id: "errmsg.empty.email" })}</span>
        ),
      });
      return false;
    }

    if (!CheckEmail(value)) {
      setMethod({
        validateStatus: "error",
        errorMsg: intl.formatMessage({ id: "errmsg.error.email" }),
      });
      return false;
    }
    return true;
  };

  const getSubmitText = () => {
    let text = intl.formatMessage({ id: "login" });
    switch (nextStepType) {
      case EMAIL_ACTION_TYPE.REGISTER:
        text = intl.formatMessage({ id: "signup.title.register" });
        break;
      case EMAIL_ACTION_TYPE.FINDPWD:
        text = intl.formatMessage({ id: "search" });
        break;
      default:
        break;
    }
    return text;
  };

  const submit = (values) => {
    const { email, password, account } = values;

    let value = "";
    let method = () => {};

    // 如果是登录页面
    if (tabsActiveKey === "1") {
      if (!submitCheck(email, setEmailStatus)) return;
      if (!password) return;

      value = email;
      method = login;
    } else if (tabsActiveKey === "2") {
      if (!submitCheck(account, setAccountStatus)) return;

      value = account;
      if (nextStepType === "findpwd") {
        method = findpwd;
      } else {
        method = register;
      }
    }

    value = value.toLocaleLowerCase();
    getStart(value, method);
  };

  const getStart = async (email, method) => {
    if (loading) {
      return false;
    }
    setLoading(true);
    props.setGlobalEmail(email);
    try {
      await method({
        account: email,
        password: password,
      });
    } catch (error) {
      console.error("getStart: ", error);
    }

    setLoading(false);
  };

  const autoJoinOrg = (account, invite_code) => {
    setLoading(true);
    PostTeamJoin({
      account: account,
      invite_code: invite_code,
    })
      .then((rsp) => {
        if (CheckSystem.Felo()) {
          const { loginKey, login_key } = rsp;
          props.setGlobalLoginKey(loginKey || login_key);
          history.push("/download");
        } else {
          OpenBrowserUrl(getRedirectUrl());
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const login = async ({ account, password }) => {
    await PostAuthLogin({
      account: account,
      password: password,
      device_type: getDeviceType(),
      lang: LOCAL_LANG[intl.locale],
    })
      .then((rsp) => {
        const { status, mfaCheck, inviteStatus, recheckKey, loginKey } = rsp;
        let nextPath = getNextPathByRegisterStatus(status);

        if (mfaCheck) {
          props.setGlobalEmailCheckKey(recheckKey);
          history.push({ pathname: "/verify_mfa" });
          return;
        }
        const isLoginClient = loginKey && isClient;
        if (isLoginClient) {
          props.setGlobalLoginKey(loginKey);
        }
        if (inviteStatus) {
          if (isLoginClient) {
            nextPath = "/download";
          }
          history.replace({
            pathname: "/invite_list",
            data: { nextPath: nextPath },
          });
        } else {
          if (props.inviteCode) {
            // 邀请页面过来的自动加入该组织
            autoJoinOrg(account, props.inviteCode);
            return;
          }
          if (isLoginClient) {
            history.push("/download");
            return;
          }
          //11 需要校验邮箱的用户
          console.log(props);
          if (status === 11) {
            props.setGlobalEmailActionType("register");
            verifyEmail(account);
            return;
          }
          history.replace(nextPath);
        }
      })
      .catch(async ({ code, msg }) => {
        switch (code) {
          case errCode.NOT_SET_PWD:
          case errCode.USER_PASSWORD_NOT_CORRECT:
            setPasswordStatus({
              validateStatus: "error",
              errorMsg: <ErrorHintText text={msg} />,
            });
            break;
          case errCode.USER_NOT_REGISTER:
            setEmailStatus({
              validateStatus: "error",
              errorMsg: <ErrorHintText text={msg} />,
            });
            break;
          default:
            // 把登录请求预期外的错误都显示在这里。
            setPasswordStatus({
              validateStatus: "error",
              errorMsg: <ErrorHintText text={msg} />,
            });
            break;
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const verifyEmail = (account) => {
    setNextStepType("register");
    props.setGlobalEmailActionType("register");
    PostEmailRegisterSend({
      account,
      device_type: getDeviceType(),
      lang: LOCAL_LANG[intl.locale],
    }).then((res) => {
      history.replace("/verify");
    });
  };

  const register = useEvent(async ({ account }) => {
    googleStatis("Signup", "Signup_create account");

    await PostEmailRegisterCheck({
      email: account,
    })
      .then((res) => {
        // 注册 验证完邮箱后设置密码（跳转设置密码页面）
        if (res.created) {
          message.error(intl.formatMessage({ id: "err_code_v5_012" }));
          emailActionType("");
        } else {
          // 未使用 跳转设置密码
          props.setGlobalEmailActionType(nextStepType);
          history.replace("/set_pwd");
        }

        if (res && res.token) {
          props.setGlobalToken(res.token);
        }
      })
      .catch(({ _, msg }) => {
        setAccountStatus({
          validateStatus: "error",
          errorMsg: <ErrorHintText text={msg} />,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  });

  const findpwd = useEvent(async ({ account }) => {
    await PostEmailSend({
      account: account,
      device_type: getDeviceType(),
      lang: LOCAL_LANG[intl.locale],
      check_type: nextStepType, // 区分是注册还是找回密码
    })
      .then((rsp) => {
        if (rsp && rsp.token) {
          props.setGlobalToken(rsp.token);
        }
        if (nextStepType) {
          props.setGlobalEmailActionType(nextStepType);
        }
        history.push({ pathname: "/verify", data: { showSentAlert: true } });
      })
      .catch(({ code, msg }) => {
        messageApi.open({
          type: "error",
          content: intl.formatMessage({ id: "verify.code.send.error" }),
          className: "custom-ant-alert",
        });
        setAccountStatus({
          validateStatus: "error",
          errorMsg: <ErrorHintText text={msg} />,
        });
      });
  });

  const openSnsInIframe = (url) => {
    if (loading) {
      return;
    }

    setLoading(true);

    const version = isClient ? "v3" : "v5";

    const redirectUri = "/login_popup_callback";

    let snsUrl =
      url + "?" + qs.stringify({ version, redirect_url: redirectUri });

    googleStatis("sns_login", { url: url });

    const openWindowReference = window.open(
      snsUrl,
      "_blank",
      "width=400,height=600"
    );

    if (openWindowReference) {
      openWindowReference.focus();
    }

    let timer = -1;
    let timeout = -1;

    timer = setInterval(() => {
      if (openWindowReference && openWindowReference.closed) {
        clearInterval(timer);
        clearTimeout(timeout);

        // check login status
        GetLoginStatus()
          .then((res) => {
            if (res.isLogin && props.redirectUri) {
              const newHref = decodeURIComponent(props.redirectUri);
              openRedirectUrl(newHref);
            } else {
              window.location.reload();
            }
          })
          .catch((error) => {
            googleStatis("sns_login_failed", {
              url: url,
              reason: error?.message || error || "get login status error",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }, 1000);

    timeout = setTimeout(() => {
      clearInterval(timer);

      setLoading(false);

      if (openWindowReference) {
        openWindowReference.close();
      }

      googleStatis("sns_login_failed", {
        url: url,
        reason: "sns login timeout: 5 mins",
      });
    }, 1000 * 60 * 5);
  };

  const openSns = (url) => {
    if (loading) return;

    const hasInIframe = inIframe();

    if (hasInIframe) {
      openSnsInIframe(url);

      return;
    }

    setLoading(true);
    const version = isClient ? "v3" : "v5";
    let snsUrl =
      url +
      `?version=${version}` +
      (props.redirectUri ? `&redirect_url=${props.redirectUri}` : "");

    // 统计
    googleStatis("sns_login", { url: url });
    window.location.href = snsUrl;
  };

  useEffect(() => {
    if (sessionStorage.getItem("register")) {
      setTabsActiveKey("2");
      setNextStepType("register");
      sessionStorage.removeItem("register");
    }
    getUrlParam("redirect_url").then((url) => {
      if (url) {
        props.setGlobalRedirectUri(url);
      }
    });
  }, []);
  function getobj(path) {
    var obj = {}; //接收最终返回的内容
    var arr;
    var str = path.split("?")[1];
    if (str != undefined) {
      arr = str.split("&"); //若参数需要用&分开，说明有多个参数，则将字符串用&分割开为数组，一次性给arr
      let arr1; //arr1用于接收每个元素里面的用"="分割开的新元素
      for (var i = 0; i < arr.length; i++) {
        //for循环，将每个参数的参数名和参数值放入obj
        arr1 = arr[i].split("="); //重新赋值
        obj[arr1[0]] = arr1[1]; //给对象obj添加新的属性及属性值
      }
      return obj;
    }
  }
  useEffect(() => {
    var path = "";
    if (getRedirectUrl().indexOf("recommend") >= 0) {
      path = getRedirectUrl();
    } else {
      path = window.location.href;
    }
    const info = getobj(path);
    if (info && info.recommend) {
      window.sessionStorage.setItem("recommend", info.recommend);
    }
  }, []);
  useEffect(() => {
    setEmailStatus({
      validateStatus: "success",
      errorMsg: null,
    });
    setAccountStatus({
      validateStatus: "success",
      errorMsg: null,
    });
    if (showBackBtn()) return;

    setTimeout(() => {
      inputFocus();
    }, 300);
  }, [tabsActiveKey]);

  const isForgetPwd = nextStepType === EMAIL_ACTION_TYPE.FINDPWD;

  const snsList = (
    <section className="sns-section">
      <div className="sns-list">
        <Button
          type="text"
          size="small"
          icon={<GoogleIcon title="Google" />}
          onClick={() => {
            googleStatis("Signup", "Signup_google");
            openSns(SNS_CALLBACK_URL.GOOGLE);
          }}
        />
        <Button
          type="text"
          size="small"
          icon={<TwitterIcon title="Twitter" />}
          onClick={() => {
            googleStatis("Signup", "Signup_twitter");
            openSns(SNS_CALLBACK_URL.TWITTER);
          }}
        />
        <Button
          type="text"
          size="small"
          icon={<FaceBookIcon title="Facebook" />}
          onClick={() => {
            googleStatis("Signup", "Signup_facebook");
            openSns(SNS_CALLBACK_URL.FACEBOOK);
          }}
        />
        <Button
          type="text"
          size="small"
          icon={<GithubIcon title="Github" />}
          onClick={() => {
            googleStatis("Signup", "Signup_github");
            openSns(SNS_CALLBACK_URL.GITHUB);
          }}
        />
      </div>
    </section>
  );

  const backToLoginContent = tabsActiveKey === "2" && (
    <div className={`btn-center mt-10 back-to-login`}>
      {nextStepType === EMAIL_ACTION_TYPE.REGISTER ? (
        <span className="question">
          {intl.formatMessage({
            id: "back.to.login.question",
          })}
        </span>
      ) : null}
      <Button
        type={"link"}
        size={"small"}
        onClick={() => {
          emailActionType("");
        }}
      >
        {intl.formatMessage({
          id:
            nextStepType === EMAIL_ACTION_TYPE.REGISTER
              ? "login"
              : "back.to.login",
        })}
      </Button>
    </div>
  );

  const privacyContent = (
    <section className={`mt-12`}>
      <p
        className="privacy-text"
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage(
            { id: "privacy.text" },
            {
              privacy: `<a href="https://felo.me/terms.html" target='_blank'>
              ${intl.formatMessage({ id: "privacy" })}
          </a>`,
              terms: `<a href="https://felo.me/privacy.html" target='_blank'>
              ${intl.formatMessage({ id: "terms" })}
          </a>`,
            }
          ),
        }}
      ></p>
    </section>
  );

  const formContent = (
    <section>
      <Form form={form} onFinish={submit}>
        <Tabs
          activeKey={tabsActiveKey}
          animated={true}
          renderTabBar={() => <></>}
        >
          <TabPane key="1">
            <Form.Item
              name="email"
              validateStatus={emailStatus.validateStatus}
              help={emailStatus.errorMsg}
              onChange={emailOnChange}
              className="account-input"
            >
              <Input
                autoComplete="off"
                placeholder={intl.formatMessage({
                  id: "account.email",
                })}
                size="large"
                disabled={loading}
              />
            </Form.Item>
            <Form.Item
              name="password"
              onChange={pwdOnChange}
              validateStatus={passwordStatus.validateStatus}
              help={passwordStatus.errorMsg}
              className="password-input"
            >
              <Input.Password
                autoComplete="off"
                placeholder={intl.formatMessage({ id: "password" })}
                size="large"
                disabled={loading}
              />
            </Form.Item>
          </TabPane>
          <TabPane key="2">
            <Form.Item
              name="account"
              validateStatus={accountStatus.validateStatus}
              help={accountStatus.errorMsg}
              onChange={accountOnChange}
              className="account-input"
            >
              <Input
                autoComplete="off"
                placeholder={intl.formatMessage({
                  id: "account.email",
                })}
                size="large"
                disabled={loading}
              />
            </Form.Item>
          </TabPane>
        </Tabs>
        {tabsActiveKey === "1" && (
          <div
            className="forgot-password-container"
            style={{
              marginTop: passwordStatus.errorMsg ? "" : "12px",
            }}
          >
            <Button
              type={"link"}
              size={"small"}
              onClick={() => {
                emailActionType(EMAIL_ACTION_TYPE.FINDPWD);
              }}
            >
              {intl.formatMessage({ id: "btn.forget.pwd" })}
            </Button>
          </div>
        )}
        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            className={`${isClient ? "mt-10" : "mt-16"} submit-button`}
            block
            size="large"
            type="primary"
            htmlType="submit"
            loading={loading}
            g-action={`${
              nextStepType === EMAIL_ACTION_TYPE.REGISTER
                ? "Create_account"
                : "sigin"
            }`}
            g-category="login"
            disabled={submitBtnDisabled()}
          >
            {loading ? " " : getSubmitText()}
          </Button>
        </Form.Item>
        {isForgetPwd && backToLoginContent}
        {!isForgetPwd && privacyContent}
      </Form>
    </section>
  );

  return (
    <>
      {contextHolder}
      <HeaderLogo />
      <Row justify={"start"} align="start" className={`main-content`}>
        <Col span={24}>
          <Row justify={ROW_JUSTIFY}>
            <Col span={24}>
              <div className="mb-28 page-title">
                {nextStepType ? (
                  <>
                    {nextStepType === EMAIL_ACTION_TYPE.REGISTER &&
                      intl.formatMessage({ id: "signup.title.register" })}
                    {isForgetPwd &&
                      intl.formatMessage({ id: "signup.title.findpwd" })}
                  </>
                ) : (
                  intl.formatMessage({ id: "login" })
                )}
              </div>

              {isForgetPwd ? formContent : snsList}
              <Divider plain className="desc-text">
                {intl.formatMessage({ id: "use.sns.account" })}
              </Divider>
              {isForgetPwd ? snsList : formContent}
              {tabsActiveKey === "1" && (
                <>
                  <div className={`form-bottom-wrap`}>
                    <span className="question">
                      {intl.formatMessage({
                        id: "signup.title.register.question",
                      })}
                    </span>
                    <Button
                      type={"link"}
                      size={"small"}
                      onClick={() => {
                        emailActionType(EMAIL_ACTION_TYPE.REGISTER);
                      }}
                    >
                      {intl.formatMessage({ id: "signup.title.register" })}
                    </Button>
                  </div>
                </>
              )}
              {!isForgetPwd && backToLoginContent}
              {isForgetPwd && privacyContent}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row justify={"center"}>
        {showBackBtn() && (
          <BackHeader
            onBack={() => {
              window.history.go(-1);
            }}
          />
        )}
      </Row>
      <Modal
        centered
        title={`${intl.formatMessage({ id: "set.pwd" })}`}
        visible={pwdModalVisible}
        onOk={goSetPwd}
        onCancel={togglePwdModalVisible}
      >
        <p>{intl.formatMessage({ id: "err_code_v5_010" })}</p>
      </Modal>
    </>
  );
};

const stateProps = (state) => {
  return {
    token: state.token,
    email: state.email,
    redirectUri: state.redirectUri,
    inviteCode: state.inviteCode,
  };
};

const dispatchProps = (dispatch) => ({
  setGlobalToken: (token) => {
    dispatch({
      type: "setToken",
      value: token,
    });
  },
  setGlobalEmail: (email) => {
    dispatch({
      type: "setEmail",
      value: email,
    });
  },
  setGlobalRedirectUri: (url) => {
    console.log("set redirect url:", url);
    dispatch({
      type: "setRedirectUri",
      value: url,
    });
  },
  setGlobalEmailCheckKey: (key) => {
    dispatch({
      type: "setEmailCheckKey",
      value: key,
    });
  },
  setGlobalEmailActionType: (type) => {
    dispatch({
      type: "setEmailActionType",
      value: type,
    });
  },
  setGlobalLoginKey: (key) => {
    dispatch({
      type: "setLoginKey",
      value: key,
    });
  },
});

export default connect(stateProps, dispatchProps)(LoginPage);
